import AssetFormWrapper from "../../components/asset-forms/AssetFormWrapper";

/**
 * Stock Asset Edit View
 * Now uses the unified AssetFormWrapper component
 */
const StockView = ({ assetId, startInEditMode }) => {
  return (
    <AssetFormWrapper
      mode="edit"
      subCategory="stocks"
      assetId={assetId}
      startInEditMode={startInEditMode}
    />
  );
};

export default StockView;
